export const parcelTimelineSource = 'parcels'

export const parcelTimelineEventTypes = {
  parcelCreated: 'parcel_created',
  parcelUpdated: 'parcel_updated',
}
